import React, { useEffect, useRef, useState, useCallback } from "react";
import classNames from "classnames/bind";
import Header from "./Header";
import StreamCam from "./StreamCam";
import styles from "./VideoPlayback.module.css";
import ModalSetting from "../../Administration/Camera/ModalSetting";
import ModalInfo from "../../Administration/Camera/ModalInfo";
import axiosClient from "../../../services/axiosClient";
import { useStoreContext } from "../../../hooks/useStoreContext";
import { Toast } from "../../../components";
import { useTranslation } from "react-i18next";
import { convertArray } from "../../../utils";
import ModalDownload from "../ModalDownload/ModalDownload";

const cx = classNames.bind(styles);
const VideoPlayBack = ({ cameraSelect, screen, isFullScreen, changeScreen, changeFullScreen, showModalDl, setShowModalDl, totalPages }) => {

  const [streaming, setStreaming] = useState([]);
  const [page, setPage] = useState(1);
  const [infoCamera, setInfoCamera] = useState([])
  const [isModalInfo, setIsModalInfo] = useState(false);
  const [isLoad, setIsLoad] = useState(false)
  const [isRefresh, setIsRefresh] = useState(false);
  const [isSetting, setIsSetting] = useState(false);
  const { t } = useTranslation()
  // eslint-disable-next-line
  const [dataStore, dispatch] = useStoreContext()

  const ref = useRef();
  const updateStreaming = (data) => {
    setStreaming(data)
  }
  const onChangeScreen = useCallback((data) => {
    changeScreen(data)
    // eslint-disable-next-line
  }, [])

  const escFunction = useCallback((event) => {
    if (event.keyCode === 27) {
      changeFullScreen(false)
    } else if (event.keyCode === 122) {
      changeFullScreen(!isFullScreen)
    }
  }, [isFullScreen, changeFullScreen]);
  React.useEffect(() => {
    if (ref) {
      if (isFullScreen) {
        ref.current.requestFullscreen();
      }
      if (!isFullScreen && document.fullscreenElement) {
        document.exitFullscreen();
      }
    }
    const setScreen = (e) => {
      if (!document.fullscreenElement) {
        changeFullScreen(false)
      }
    }
    document.addEventListener("keydown", escFunction);
    document.addEventListener('fullscreenchange', setScreen);
    return () => {
      document.removeEventListener("keydown", escFunction);
      document.addEventListener('fullscreenchange', setScreen);
    };
  }, [isFullScreen, ref, escFunction, changeFullScreen]);
  React.useEffect(() => {
    const getListPathStreaming = async () => {
      if (cameraSelect && cameraSelect.length > 0) {
        let listCamera = [];
        dataStore.listCodeCamera.forEach(element => {
          listCamera = [...element.data, ...listCamera]
        });
        // setTotal(cameraSelect.length);
        const listStream = cameraSelect.map((item) => {
          let camera = listCamera?.find(item1 => item.camera_code === item1.code)
          return {
            url: `${process.env.REACT_APP_BASE_URL}${item?.path.IS_STREAM ? 'livestream' : 'playback'}/${item.path?.PATH}`,
            isOption: false,
            name_cam: item?.name_cam,
            status: item.path !== "no-path" ? item.status : "no-video",
            code: item.camera_code,
            time_start: item.path?.TIME_START?.split(' ')[1],
            time_end: item.path?.TIME_END?.split(' ')[1],
            st: item.status,
            stActive: camera ? camera.camStatusActive : 0,
            next_url: `${process.env.REACT_APP_BASE_URL}${item?.path.IS_STREAM ? 'livestream' : 'playback'}/${item?.next_path?.PATH}`,
            time_next: item.next_path?.TIME_START ? item.next_path?.TIME_START.split(' ')[1] : "No-video",
            recorder_code: item?.recorder_code,
            path: item.path?.PATH
          };
        });
        setStreaming(listStream);
      } else {
        setStreaming([]);
      }
    }
    getListPathStreaming()
  }, [cameraSelect, dataStore.toggleNotification]);

  useEffect(() => {
    setPage(totalPages / screen < 1 ? 1 : Math.ceil(totalPages / screen));
  }, [screen, totalPages]);

  const getDataCamera = async (code) => {
    setIsLoad(true)
    try {
      const res = await axiosClient.get(`cameraManagement/get-camera-info-by-code/?camera_code=${code}`)
      setInfoCamera(res)
      setIsLoad(false)
    } catch (error) {
      Toast.open(t("playback.noPermissionViewInfoCam"), 'danger')
    }
  }

  const handleGetShowInfoCamera = (code) => {
    setIsModalInfo(!isModalInfo)
    getDataCamera(code)
  }

  const handleClose = () => {
    setIsModalInfo(!isModalInfo)
  }

  const handleCloseSetting = () => {
    setIsSetting(!isSetting)
  }
  const handleGetShowSetting = async (code) => {
    await getDataCamera(code)
    setIsSetting(!isSetting)
  }
  return (
    <div
      ref={ref}
    >
      {isFullScreen && (
        <Header
          screen={screen}
          setScreen={onChangeScreen}
          isFullScreen={isFullScreen}
          setIsFullScreen={(data) => changeFullScreen(data)}
        />
      )}
      <StreamCam
        streaming={streaming}
        screen={screen}
        setScreen={onChangeScreen}
        isFullScreen={isFullScreen}
        useRef={ref}
        setStreaming={updateStreaming}
        page={page}
        getCodeInfo={handleGetShowInfoCamera}
        getCodeSetting={handleGetShowSetting}
        showModalDl={showModalDl}
        setShowModalDl={setShowModalDl}
      />

      {isModalInfo && (
        <div className={cx('modal-detail')}>
          <ModalInfo
            camera={infoCamera}
            onClose={handleClose}
            show={isModalInfo}
            loading={isLoad}
          />
        </div>
      )}

      {isSetting && (
        <div className={cx('modal-detail')}>
          <ModalSetting
            onclose={handleCloseSetting}
            setIsRefresh={setIsRefresh}
            isRefresh={isRefresh}
            camera={infoCamera}
          />
        </div>
      )}
      {showModalDl && convertArray(dataStore.listCodeCamera).length > 0 && (

        <ModalDownload
          listCamera={convertArray(dataStore.listCodeCamera)}
          setShowModalDl={setShowModalDl}
          showModalDl={showModalDl}
        />

      )}
    </div>
  );
};
export default VideoPlayBack;
